import PropTypes from "prop-types";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";

// import TinyEditor from "@/pages/configuration/components/TinyEditor";
import TinyEditor from "@/pages/configuration/components/Editor";
import FormInput from "@/components/forms/FormInput";

const validationSchema = Yup.object().shape({
  privacyPolicy: Yup.string()
    .required("Privacy Policy is required")
    .min(11, "Privacy Policy must be at least 5 characters")
    .label("Privacy Policy")
    .trim(),
  termsConditions: Yup.string()
    .required("Terms and Conditions is required")
    .min(11, "Terms and Conditions must be at least 5 characters")
    .label("Terms and Conditions")
    .trim(),
  about: Yup.string()
    .required("About is required")
    .min(11, "About must be at least 5 characters")
    .label("About")
    .trim(),
  pricingWorks: Yup.string()
    .required("Pricing Works is required")
    .min(11, "Pricing Works must be at least 5 characters")
    .label("Pricing Works")
    .trim(),
  advertise: Yup.string()
    .required("Advertise is required")
    .min(11, "Advertise must be at least 5 characters")
    .label("Advertise")
    .trim(),
  media: Yup.string()
    .required("Media is required")
    .min(11, "Media must be at least 5 characters")
    .label("Media")
    .trim(),
});

function ConfigForm({ onSubmit, isLoading, initialValues }) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ setFieldValue, setFieldTouched, setFieldError, handleSubmit }) => (
        <Box
          sx={{
            margin: "50px",
            // width: "400px",
            display: "flex",
            flexDirection: "column",
            gap: 1.8,
          }}
        >
          <Typography variant="subtitle1">Privacy And Policy</Typography>
          <TinyEditor
            label="Privacy Policy"
            name="privacyPolicy"
            dataTextName="privacyPolicyText"
            type="text"
            onChangeText={(value) => {
              setFieldValue("privacyPolicyText", value);
            }}
            onBlur={() => {
              setFieldTouched("privacyPolicyText", true);
            }}
            onChange={(value) => {
              // setFieldTouched("privacyPolicyText", true);
              setFieldTouched("privacyPolicy", true);
              setFieldValue("privacyPolicy", value);
            }}
            onError={(message) => {
              setFieldError("privacyPolicy", message);
            }}
          />
          <Typography variant="subtitle1">Terms and Conditions</Typography>
          <TinyEditor
            label="Terms and Conditions"
            name="termsConditions"
            dataTextName="termsConditionsText"
            type="text"
            onChangeText={(value) => {
              setFieldValue("termsConditionsText", value);
            }}
            onBlur={() => {
              setFieldTouched("termsConditionsText", true);
            }}
            onChange={(value) => {
              // setFieldTouched("termsConditionsText", true);
              setFieldTouched("termsConditions", true);
              setFieldValue("termsConditions", value);
            }}
            onError={(message) => {
              setFieldError("termsConditions", message);
            }}
          />

          <Typography variant="subtitle1">About Us</Typography>
          <FormInput label="About Us" name="about" type="text" />

          <Typography variant="subtitle1">Advertise</Typography>
          <FormInput label="Advertise" name="advertise" type="text" />

          <Typography variant="subtitle1">Media</Typography>
          <FormInput label="Media" name="media" type="text" />

          <Typography variant="subtitle1">Pricing Works</Typography>
          <FormInput label="Pricing Works" name="pricingWorks" type="text" />

          <Button
            variant="contained"
            fullWidth
            type="submit"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? <CircularProgress /> : "Submit"}
          </Button>
        </Box>
      )}
    </Formik>
  );
}

ConfigForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    privacyPolicy: PropTypes.string,
    privacyPolicyText: PropTypes.string,
    termsConditions: PropTypes.string,
    termsConditionsText: PropTypes.string,
  }).isRequired,
};

export default ConfigForm;
